import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import PageSEO from "../../utils/PageSEO";
import { useTranslation } from "../../i18n";

function Experience() {
  const { t } = useTranslation();
  const experiences = t("experience.items");

  const experienceStructuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://yuvasree.online/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Experience",
        "item": "https://yuvasree.online/experience"
      }
    ]
  };

  return (
    <>
      <PageSEO
        title="Work Experience | Yuvasree Padmanabhan | Automation Engineer"
        description="Professional experience of Yuvasree Padmanabhan at Ncompass TechStudio as Automation Engineer. Explore career timeline, technical skills gained, and professional growth journey."
        keywords="Yuvasree experience, Automation Engineer, Ncompass TechStudio, professional experience, career, test automation, scripting experience, software development"
        url="https://yuvasree.online/experience"
        structuredData={experienceStructuredData}
      />
      <Container fluid className="experience-section">
        <Particle />
        <Container>
        <h1 className="project-heading">
          <strong className="purple">{t("experience.titleHighlight")} </strong>
        </h1>
        <p className="experience-subheading">{t("experience.subtitle")}</p>

        <div className="experience-timeline">
          {Array.isArray(experiences) &&
            experiences.map((exp, index) => (
              <div className="timeline-item" key={exp.id}>
                <div className="timeline-marker">
                  <span className="timeline-dot" />
                  {index < experiences.length - 1 && (
                    <span className="timeline-line" />
                  )}
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-company">{exp.company}</h3>
                  <p className="timeline-role">{exp.role}</p>
                  <p className="timeline-period">{exp.period}</p>
                  <ul className="timeline-points">
                    {exp.points.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
        </div>
      </Container>
    </Container>
    </>
  );
}

export default Experience;
